/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
  InputAdornment,
  IconButton,
  Paper,
  Container,
  Avatar,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Email as EmailIcon,
  Lock as LockIcon,
  Person as PersonIcon,
  Smartphone as MobileIcon
} from '@mui/icons-material';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { changeAppToken } from '../../redux/slices/applicationTokenSlice';
import { changeLoginData } from '../../redux/slices/loginSlice';
import moment from 'moment';

const UserLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const appToken = useSelector((state) => state.appToken.apptoken);
  const formId = searchParams.get('formId'); // URL'den formId parametresini al

  // Login için sabit token kullanılıyor
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  axios.get("https://app.hhoms.com/api/form/Libraries/" + formId, {
    headers: {
      'Content-Type': 'application/json-patch+json',
      ApplicationToken: appToken ? appToken : 'mete'
    }
  }).then(response => {
    if (response.data.formLibraries && response.data.formLibraries.length > 0) {
      let gatheredFormData = JSON.parse(response.data.formLibraries[0].formContent);
      console.log('Fetched form data for formId', formId, gatheredFormData);
      if (gatheredFormData.settings.loginRequired || gatheredFormData.settings.loginRequired == undefined || gatheredFormData.settings.loginRequired == null) {
        console.log('Form için giriş gerekli');
      } else {
        console.log('Form için giriş gerekli değil, direkt forma yönlendiriliyor');
        setTimeout(() => {
          window.location.href = "/user-form/" + formId;
        }, 1000);
      }
    }

  });

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Sayfa yüklendiğinde kontrol et
  useEffect(() => {
    // Ana panel kullanıcısı giriş yapmışsa, form kullanıcısı giriş yapamaz
    const panelUserToken = localStorage.getItem('userToken');
    const panelUserData = localStorage.getItem('userData');

    if (panelUserToken && panelUserData) {
      try {
        const parsedUserData = JSON.parse(panelUserData);
        // Eğer panel kullanıcısı giriş yapmışsa ve form kullanıcısı değilse
        if (parsedUserData && parsedUserData.id && !parsedUserData.userType) {
          console.log('Panel user already logged in, redirecting to dashboard');
          navigate('/');
          return;
        }
      } catch (error) {
        console.error('Error parsing stored user data:', error);
      }
    }

    // Form kullanıcısı zaten giriş yapmışsa dashboard veya forma yönlendir
    const formUserToken = localStorage.getItem('formUserToken');
    const formUserData = localStorage.getItem('formUserData');

    if (formUserToken && formUserData) {
      try {
        const parsedUserData = JSON.parse(formUserData);
        if (parsedUserData && parsedUserData.id) {
          console.log('Form user already logged in');
          // Eğer URL'de formId parametresi varsa direkt forma yönlendir
          if (formId) {
            navigate(`/user-form/${formId}`);
          } else {
            navigate('/user-dashboard');
          }
        }
      } catch (error) {
        console.error('Error parsing stored form user data:', error);
        // Hatalı veri varsa temizle
        localStorage.removeItem('formUserToken');
        localStorage.removeItem('formUserData');
      }
    }
  }, [navigate]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    // Hata mesajını temizle
    if (error) {
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      setError('E-posta ve şifre gereklidir');
      return;
    }

    setLoading(true);
    setError('');

    try {
      console.log('Attempting form user login with:', {
        Email: formData.email,
        Password: formData.password
      });

      const response = await axios.post(
        'https://app.hhoms.com/api/form/FormUsers/login',
        {
          Email: formData.email,
          Password: formData.password
        },
        {
          headers: {
            'Content-Type': 'application/json-patch+json',
            ApplicationToken: '7db7cfd1-6ea2-487d-8f0a-a830e31eff94'
          },
          timeout: 10000 // 10 saniye timeout
        }
      );

      const responseData = response.data;
      console.log('API Response:', responseData);
      let userData = null;
      let token = null;
      if (responseData.formUsers && Array.isArray(responseData.formUsers) && responseData.formUsers.length > 0) {
        userData = responseData.formUsers[0];
        token = userData.token;
        console.log('Found user in formUsers array:', userData);
      } else if (responseData.id) {
        userData = responseData;
        token = userData.token;
        console.log('Found user in direct response:', userData);
      } else {
        console.error('Unexpected API response format:', responseData);
        setError('Server response format is unexpected');
        return;
      }

      if (!token) {
        setError('Token could not be received from server, please contact system administrator.');
        console.error('API yanıtında token yok:', userData);
        setLoading(false);
        return;
      }
      console.log('Kullanıcı token:', token);

      if (response.status === 200 && userData && userData.id) {
        console.log('Login başarılı, token Redux\'a kaydediliyor:', token);

        // Form kullanıcısı için token'ı Redux'a kaydet
        dispatch(changeAppToken(token));

        // Redux store'u kontrol et
        setTimeout(() => {
          const currentToken = localStorage.getItem('applicationToken');
          console.log('Redux store\'a kaydedilen token:', currentToken);
          console.log('Token doğru kaydedildi mi?', currentToken === token);
        }, 100);

        // Login verilerini kaydet
        const loginData = {
          id: userData.id,
          username: userData.email,
          password: userData.password,
          loginDate: moment().format("DD.MM.YYYY HH:mm"),
          userType: 'formUser',
          userData: {
            name: userData.name,
            email: userData.email,
            categories: userData.categories,
            isActive: userData.isActive,
            token: token,
            ownerToken: userData.ownertoken || userData.ownerToken // API'den gelen ownertoken'ı kullan
          }
        };
        console.log('Login data Redux\'a kaydediliyor:', loginData);
        dispatch(changeLoginData(loginData));

        // localStorage'a kaydet
        localStorage.setItem('formUserToken', token);
        localStorage.setItem('formUserType', 'formUser');
        localStorage.setItem('formUserData', JSON.stringify({
          id: userData.id,
          username: userData.email,
          userData: {
            name: userData.name,
            email: userData.email,
            categories: userData.categories,
            isActive: userData.isActive,
            token: token
          }
        }));

        console.log('Tüm token kayıtları tamamlandı');
        console.log('formUserToken:', localStorage.getItem('formUserToken'));
        console.log('applicationToken:', localStorage.getItem('applicationToken'));

        setSuccess('Giriş başarılı! Yönlendiriliyorsunuz...');
        setTimeout(() => {
          // Eğer URL'de formId parametresi varsa direkt forma yönlendir
          if (formId) {
            navigate(`/user-form/${formId}`);
          } else {
            navigate('/user-dashboard');
          }
        }, 1000);
      } else {
        setError('Giriş başarısız: Geçersiz kullanıcı bilgileri');
      }
    } catch (error) {
      console.error('Form user login error:', error);

      if (error.response) {
        // Sunucu yanıt verdi ama hata kodu döndü
        const status = error.response.status;
        const message = error.response.data?.message || error.response.statusText;

        if (status === 401) {
          setError('E-posta veya şifre hatalı');
        } else if (status === 404) {
          setError('Kullanıcı bulunamadı');
        } else if (status === 500) {
          setError('Sunucu hatası. Lütfen daha sonra tekrar deneyin.');
        } else {
          setError(`Giriş başarısız: ${message}`);
        }
      } else if (error.request) {
        // İstek yapıldı ama yanıt alınamadı
        setError('Sunucuya bağlanılamıyor. Lütfen internet bağlantınızı kontrol edin.');
      } else if (error.code === 'ECONNABORTED') {
        setError('Bağlantı zaman aşımı. Lütfen tekrar deneyin.');
      } else {
        // İstek oluşturulurken hata oluştu
        setError(`Bağlantı hatası: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: isMobile ? 2 : 4
    }}>
      <Container maxWidth="sm">
        <Paper
          elevation={8}
          sx={{
            p: isMobile ? 3 : 4,
            borderRadius: 4,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}
        >
          {/* Header */}
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            {/*  <Avatar 
              sx={{ 
                width: isMobile ? 60 : 80, 
                height: isMobile ? 60 : 80, 
                mx: 'auto', 
                mb: 2,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
              }}
            >
              <MobileIcon sx={{ fontSize: isMobile ? 30 : 40 }} />
            </Avatar> */}
            {/* <Typography 
              variant={isMobile ? "h5" : "h4"} 
              component="h1" 
              gutterBottom
              sx={{ 
                fontWeight: 700,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              Mobil Giriş
            </Typography> */}
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                fontSize: isMobile ? '0.875rem' : '1rem',
                opacity: 0.8
              }}
            >
              {formId ? `Form doldurma işlemi için giriş yapın (Form ID: ${formId})` : 'Form sistemine erişim için giriş yapın'}
            </Typography>
          </Box>

          {/* Hata ve başarı mesajları */}
          {error && (
            <Alert
              severity="error"
              sx={{
                mb: 3,
                borderRadius: 2,
                fontSize: isMobile ? '0.75rem' : '0.875rem'
              }}
              onClose={() => setError('')}
            >
              {error}
            </Alert>
          )}

          {success && (
            <Alert
              severity="success"
              sx={{
                mb: 3,
                borderRadius: 2,
                fontSize: isMobile ? '0.75rem' : '0.875rem'
              }}
            >
              {success}
            </Alert>
          )}

          {/* Form */}
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="E-posta"
              type="email"
              value={formData.email}
              onChange={(e) => handleInputChange('email', e.target.value)}
              margin="normal"
              required
              disabled={loading}
              size={isMobile ? "small" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 3,
                  fontSize: isMobile ? '0.875rem' : '1rem',
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main'
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                    borderWidth: 2
                  }
                },
                '& .MuiInputLabel-root': {
                  fontSize: isMobile ? '0.875rem' : '1rem'
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon color="primary" />
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              fullWidth
              label="Şifre"
              type={showPassword ? 'text' : 'password'}
              value={formData.password}
              onChange={(e) => handleInputChange('password', e.target.value)}
              margin="normal"
              required
              disabled={loading}
              size={isMobile ? "small" : "medium"}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 3,
                  fontSize: isMobile ? '0.875rem' : '1rem',
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main'
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                    borderWidth: 2
                  }
                },
                '& .MuiInputLabel-root': {
                  fontSize: isMobile ? '0.875rem' : '1rem'
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon color="primary" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      disabled={loading}
                      size={isMobile ? "small" : "medium"}
                    >
                      {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size={isMobile ? "large" : "large"}
              disabled={loading}
              sx={{
                mt: 4,
                mb: 2,
                py: isMobile ? 1.5 : 2,
                borderRadius: 3,
                fontSize: isMobile ? '1rem' : '1.1rem',
                fontWeight: 600,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
                  boxShadow: '0 6px 20px rgba(102, 126, 234, 0.6)',
                  transform: 'translateY(-2px)'
                },
                '&:disabled': {
                  background: 'linear-gradient(135deg, #bdbdbd 0%, #9e9e9e 100%)',
                  boxShadow: 'none'
                },
                transition: 'all 0.3s ease'
              }}
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <PersonIcon />}
            >
              {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
            </Button>

            {/* Ana panel girişi için buton */}
            <Button
              fullWidth
              variant="outlined"
              size={isMobile ? "large" : "large"}
              disabled={loading}
              onClick={() => navigate('/login')}
              sx={{
                mb: 2,
                py: isMobile ? 1.5 : 2,
                borderRadius: 3,
                fontSize: isMobile ? '1rem' : '1.1rem',
                fontWeight: 600,
                borderColor: '#4158D0',
                color: '#4158D0',
                '&:hover': {
                  borderColor: '#C850C0',
                  color: '#C850C0',
                  background: 'rgba(65, 88, 208, 0.05)',
                  transform: 'translateY(-2px)'
                },
                '&:disabled': {
                  borderColor: '#bdbdbd',
                  color: '#9e9e9e'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Panel Kullanıcısı Girişi
            </Button>

            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  opacity: 0.7,
                  lineHeight: 1.5
                }}
              >
                Sorun yaşıyorsanız sistem yöneticisi ile iletişime geçin
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default UserLogin; 